import { CAlert, CButton, CContainer, CInput, CModal, CModalBody, CModalFooter, CRow, CToast, CToastBody, CToastHeader } from '@coreui/react';
import moment from 'moment';
import * as React from 'react';
import { match, Redirect } from 'react-router-dom';
import { ControlTypeEnum, IAction, IAPICallResult, IColumnDef, IControl, IGetDynListParams, IServiceMessage, ITable, IUploadPath, IViewContext, IViewContextParams } from '../abstraction';
import { KPanel, KActionList, NavMenu, IActionModel } from '../components/';
import { KControlTableSwitch, KControlAction, KControlAttachment, KControlCheckbox, KControlImage, KControlInput, KControlJauge, KControlLabel, KControlProgress, KControlRTF, KControlSelect, KControlTable, KControlHTMLEditor } from '../components/Controls';
import { KControlHTMLViewer } from '../components/Controls/KControlHTMLViewer';
import { AppLabels } from '../core/AppLabels';
import { Utils } from '../core/utils';
import { barCodeSvc, dispatcher, Karma, securitySvc } from '../Karma';
import { ActionModel, ActionPosition, ColumnModel, ControlModel, InternalTypeEnum, TableModel } from '../models/index';
import { PanelModel } from '../models/PanelModel';

export interface IViewParams {
    fnct: string;
}

interface IProps {
    match?: match<IViewParams>;
    widget?: boolean;
}

interface IState {
    codecontext: string;
    loading: boolean;
    redirectUrl: string;
    Controls: ControlModel[];
    Actions: ActionModel[];
    tables: TableModel[];
    title: string;
    focus: string;
    currentStep: number;
    fonction: string;
    nbCols: number;
    disableHomeRedirection: boolean;
    showEmbedded: boolean;

    showButtonList: boolean;
    buttonList: ActionModel[];

    panels: PanelModel[];

    // Les propriétés suivantes concerne le générateur d'écran
    simulateMode: boolean;
    showResult: boolean,
    json: string;
    error: string;

    // 
    multiMode: boolean;

    // 
    isPopupOpen: boolean;
    popupCode: string;

    uploadedFiles: string[];
}

const parseRTF = require('rtf2text');

// Generateur de vue
export class GenView extends React.Component<IProps, IState> {
    static URL: string = "/stdView";

    public constructor(props: any) {
        super(props);

        let showResult: boolean = true;
        let sim = this.props.match.params.fnct == "GENERATOR";
        if (sim) showResult = false;

        this.state = {
            codecontext: "INITIALISATION",
            loading: showResult,
            redirectUrl: "",
            title: "",
            Controls: [],
            Actions: [],
            tables: [],
            focus: "",
            currentStep: 1,
            fonction: this.props.match.params.fnct,
            disableHomeRedirection: false,
            showEmbedded: false,

            showButtonList: false,
            buttonList: [],
            panels: [],

            simulateMode: sim,
            showResult: showResult,
            json: "",
            error: "",

            multiMode: false,

            isPopupOpen: false,
            popupCode: "",

            nbCols: 1,

            uploadedFiles: []
        }

        barCodeSvc.OnBarCodeReceived.add((data) => { this.onBarCodeReceived(data); });

        if (showResult) {

            let ctx: IViewContextParams = {
                barCode: "",
                title: "",
                idSession: securitySvc.currentUser.id,
                idTransaction: "",
                idSite: "",
                context: this.state.codecontext,
                etape: this.state.currentStep,
                fnct: this.props.match.params.fnct,
                Controls: [],
                Tables: [],
                Actions: [],
                uploadedFiles: []
            };

            let vc = dispatcher.getLastViewContext();
            if (vc) {
                if (vc.IsWidget == true) {
                    return;
                }
            }

            this.refreshContext(ctx);
        }
    }

    //#region React Hacks

    componentWillUnmount = () => {
        barCodeSvc.OnBarCodeReceived.reset();
        window.removeEventListener('resize', this.updateDimensions);

        let infos = dispatcher.techInfosModel;
        infos.flux = "";
        infos.context = "";
        infos.step = 0;
        infos.idSite = "";
        infos.idTransaction = "";
    }

    componentDidMount = () => {
        window.addEventListener('resize', this.updateDimensions);

        let context = dispatcher.getLastViewContext();
        if (context) {
            if (context.IsWidget == true) {
                this.onViewContextReceived(context);
            }
        }
    }

    updateDimensions = () => {
        this.forceUpdate();
    };

    //#endregion

    //#region Métier et autres méthodes diverses

    // Déclenche le chargement d'un nouveau contexte en fonction de l'état de l'écran actuel
    refreshContext = (ctx: IViewContextParams) => {
        dispatcher.getViewContext(ctx).then((e) => { this.onViewContextReceived(e); }).catch((err) => { this.onViewContextReceivedError(err); });
    }

    // Balaye l'écran et construit le contexte à envoyer au serveur
    // 
    buildViewContextParams(): IViewContextParams {
        let controls: IControl[] = [];
        let tables: ITable[] = [];
        let actions: IAction[] = [];
        let uploads: IUploadPath[] = [];

        this.state.Controls.map((x, i) => {
            console.log(`genview.buildViewContextParams - ctrl ${x.Id} - type ${x.ControlType} - key ${x.Key} - value ${x.Value}`);
            if (x) {
                // dans le cas d'un composant permettant la prise de photo (x.Camera == true) ou dessin (x.DrawMode==true),
                // si une image a été uploadée (value!="") 
                // et qu'un répertoire destination est prévu pour stocker la photo,
                // on l'indique au serveur en renseignant uploads				
                if ((x.Camera == true || x.DrawMode == true) && x.Value != "") {
                    if (x.AttachmentDest) {
                        console.log(`genview.buildViewContextParams - attachment found for ctrl ${x.Id}`);
                        console.log(`genview.buildViewContextParams - destination key : ${x.AttachmentDest}`);

                        let path = securitySvc.currentUser.uploadPaths.filter(p => p.key == x.AttachmentDest)[0];

                        if (path) {
                            uploads.push({
                                key: x.Value,				// Nom du fichier
                                value: path.value,			// Destination
                            })
                        }
                        else {
                            console.log(`genview.buildViewContextParams - no path found`);
                        }
                    }
                    else {
                        console.log("WARNING : component with camera or drawmode has no upload dir defined (ATTACHDEST attribute is empty)");
                    }
                }
            }

            controls.push({
                Code: x.Key,
                Type: x.ControlType,
                Description: x.Description,
                Id: x.Id,
                Label: "",
                NoLabel: x.NoLabel,
                Value: (x.ToUpperCase && x.ToUpperCase) ? x.Value.toUpperCase() : x.Value,
                Complement1: x.Complement1,
                Complement2: x.Complement2,
                Complement3: x.Complement3,
                Visible: x.Visible,
                Disable: x.Disable,
                TypeLenght: x.TypeLenght,
                DataType: x.DataType,
                Popup: x.Popup,
                Content: (x.ControlType == ControlTypeEnum.htmlEditor) ? "<![CDATA[" + x.Content + "]]>" : x.Content,
            })
        });

        this.state.tables.map((x, i) => {

            let tabl: ITable = {
                Type: ControlTypeEnum.table,
                Rows: x.Rows,
                Code: x.Key,
                Id: x.Id,
                ColDefs: [],
                Description: "",
                Actions: [],
                SelectedRow: null,
                Visible: x.Visible,
                Disable: x.Disable,
                NewRows: "",
            };

            x.colsDef.filter(c => c.IsMerged == false).map((column, i) => {
                tabl.ColDefs.push({
                    SearchFieldName: column.ColSearchField,
                    Id: column.Id,
                    Code: column.Key,
                    FieldName: column.FieldName,
                    Title: column.Title,
                    Type: column.Type,
                    Visible: column.Visible,
                    Disable: column.Disable,
                    ColType: column.DataType,
                    Class: column.Class,
                    IsMerged: false,
                })
            });

            if (x.selectedRow) {
                tabl.SelectedRow = x.selectedRow;
            }

            x.actions.map((t, i) => {
                tabl.Actions.push(t.adapt())
            });

            tables.push(tabl)
        });

        this.state.Actions.map((x, i) => {

            actions.push({
                Type: ControlTypeEnum.action,
                Action: x.Action,
                Code: x.Key,
                Text: x.Text,
                WebService: x.WebService,
                Context: x.Context,
                Id: x.Id,
                Target: x.Target,
                Visible: x.Visible,
                Disable: x.Disable,
                //URL: x.URL,
            })
        });

        return {
            barCode: "",
            idTransaction: "",
            idSession: securitySvc.currentUser.id,
            idSite: "",
            context: "",
            title: this.state.title,
            Controls: controls,
            etape: this.state.currentStep,
            fnct: this.state.fonction,
            Tables: tables,
            Actions: actions,
            uploadedFiles: uploads,
        }
    }

    // Méthode qui balaye l'intégralité des champs de saisies et valide les données saisies.
    // Si une erreur est rencontrée, on ajoute un message d'erreur au champ concerné et on retourne false
    checkFormValidity(): boolean {
        for (let current of this.state.Controls) {
            if ((current.Required) && (current.Required == true) && (current.Value == "")) {
                current.Class += " error ";
                current.ErrorMessage = AppLabels.mandatoryField;
                this.forceUpdate();
                return false;
            }

            // Zone non obligatoire et non saisie
            if (!current.Value) return true;

            // Contrôle de validation via expression régulière
            if (current.Pattern && current.Pattern != "") {
                let regex2 = new RegExp(current.Pattern);
                if (!regex2.test(current.Value)) {
                    return false;
                }
            }

            if (current.ControlType == Number(ControlTypeEnum.input)) {
                switch (current.DataType) {
                    case InternalTypeEnum.Alpha:
                        if (current.MinLength && current.MinLength > 0) {
                            if (current.Value.length < current.MinLength) {
                                current.Class += " error ";
                                current.ErrorMessage = AppLabels.fieldTooShort;
                                this.forceUpdate();
                                return false;
                            }
                        }
                        if (current.MaxLength && current.MaxLength > 0) {
                            if (current.Value.length > current.MaxLength) {
                                current.Class += " error ";
                                current.ErrorMessage = AppLabels.fieldTooLong;
                                this.forceUpdate();
                                return false;
                            }
                        }
                        break;

                    case InternalTypeEnum.Decimal:
                    case InternalTypeEnum.Double:
                    case InternalTypeEnum.Float:
                    case InternalTypeEnum.Long:
                    case InternalTypeEnum.Short:
                        if ((current.Min) && (Number(current.Value) < current.Min)) {
                            current.Class += " error ";
                            current.ErrorMessage = AppLabels.valueTooSmall;
                            this.forceUpdate();
                            return false;
                        }
                        if ((current.Max) && (Number(current.Value) > current.Max)) {
                            current.Class += " error ";
                            current.ErrorMessage = AppLabels.valueTooHigh;
                            this.forceUpdate();
                            return false;
                        }
                        break;

                    case InternalTypeEnum.Blob:
                    case InternalTypeEnum.Clob:
                        break;

                    case InternalTypeEnum.Date:
                    case InternalTypeEnum.Datetime:
                        if (current.Value) {
                            if (!moment(current.Value).isValid()) {
                                current.Class += " error ";
                                current.ErrorMessage = AppLabels.invalidDate;
                                this.forceUpdate();
                                return false;
                            }
                        }
                        break;

                    case InternalTypeEnum.Menu:
                        break;

                    case InternalTypeEnum.Uuid:
                        break;
                    default:
                        break;
                }
            }
        }
        return true;
    }

    // Méthode appelée par la liste de sélection (callback) pour obtenir la liste des champs de la page avant appel au WS
    getDynamicListParams(): IGetDynListParams {
        let context = this.buildViewContextParams();

        let state: IGetDynListParams = {
            filters: [],
            flxCod: this.state.fonction,
            kmaZone: "",	// filled by select component 
            site: "",	// filled by dispatcher
        }

        // K0018329 
        // Si valeur null, on remplace par chaine vide
        context.Controls.map(x => {
            state.filters.push({ Key: x.Code, Value: x.Value ?? "", Id: x.Id });
        });

        context.Tables.map(x => {
            x.ColDefs.map(col => {
                state.filters.push({ Key: col.Code, Value: ((x.SelectedRow != null) && (x.SelectedRow != undefined)) ? x.SelectedRow[col.Code] : "", Id: x.Id });
            });
        });

        state.filters = state.filters.sort((a, b) => (a.Id > b.Id) ? 1 : -1);
        return state;
    }

    //#endregion

    //#region Evènements Locaux

    // Le moteur a lu un code barre
    // On recharge donc le contexte
    onBarCodeReceived = (barcode: string) => {
        dispatcher.techInfosModel.barCode = barcode;

        // TODO: Bof. 
        if (this.state.multiMode) return;

        let ctx: IViewContextParams = this.buildViewContextParams();
        ctx.context = "BARCOD";
        ctx.barCode = barcode;
        this.refreshContext(ctx);
    }

    // Un demande de chargement de contexte a échoué
    // On trace l'intégralité des messages reçus sur la console et on affiche le 1er en message box
    onViewContextReceivedError = (e: IServiceMessage[]) => {
        console.log("!! genView - onViewContextReceivedError ");
        this.setState({ loading: false });

        e.map(m => {
            console.error(`Error : ${m.message}, severity : ${m.level}`)
        })

        dispatcher.MessageBox("", e[0].message, e[0].level);
    }

    // Réception nouveau context
    // Il faut interpréter son contenu et réaliser la consttruction de l'écran
    onViewContextReceived = (viewContext: IViewContext) => {
        try {
            let infos = dispatcher.techInfosModel;
            infos.flux = viewContext.FunctionName;
            infos.userName = securitySvc.currentUser.login;
            infos.lang = Karma.getCurrentCultureCode();
            infos.context = viewContext.Context;
            infos.step = viewContext.Step;
            infos.idSite = viewContext.IdSite;
            infos.idTransaction = viewContext.IdSession + "/" + viewContext.IdTransaction;


            // Retour d'un appel à une IMPRESSION
            // On indique juste que l'impression a été prise en compte, et c'est tout / pas de rendu

            // Suppression de l'indication. D'autres context peuvent déclencher des impressions
            //if (viewContext.Context == "IMPRESSION") {
            //	dispatcher.MessageBox(AppLabels.printDialogTitle, AppLabels.printDialogContent, 2);
            //	return;
            //}
            let ctrls: ControlModel[] = [];
            let actions: ActionModel[] = [];

            // Efface l'écran
            this.setState({
                Controls: [],
                Actions: [],
                loading: false,
                title: viewContext.Description,
            });


            // Balaye les contrôles
            viewContext.Controls.map((x) => {
                let control = ControlModel.create(x)

                // Si le contrôle est de type image (et accessoirement visible)
                if ((control.ControlType == ControlTypeEnum.image) && (control.Visible)) {

                    // Value contient l'indice de l'image
                    let indice = Number(control.Value) - 1;

                    // Les images étant stockées dans un tableau dédié, on transfère le contenu sur notre controle
                    if (viewContext.Images[indice]) {
                        control.Content = viewContext.Images[indice].data;
                        control.ContentType = viewContext.Images[indice].mimetype;
                    }
                    else {
                        // Si undefined, on cache l'image
                        control.Visible = false;
                    }
                }

                // La même chose mais avec les RTF siouplé
                if ((control.ControlType == ControlTypeEnum.viewerRTF) && (control.Visible)) {

                    // RTFs stockés dans tableau Texts
                    let rtf = viewContext.Texts[Number(control.Value) - 1];

                    // ON parse le contenu
                    parseRTF.string(rtf, async (err, text) => {
                        control.Content = text;
                        control.ContentType = "text/rtf";
                        // L'appel a cette méthode étant asynchrone, on effectue une mise à jour de l'état une fois terminé
                        this.setState({ Controls: ctrls, });
                    }
                    );
                }

                // La même chose mais avec du contenu HTML
                if (((control.ControlType == ControlTypeEnum.viewerHtml) || (control.ControlType == ControlTypeEnum.htmlEditor)) && (control.Visible)) {
                    // Contenu stocké dans tableau Texts
                    control.Content = viewContext.Texts[Number(control.Value) - 1];
                    if (control.Content != null) {
                        if (control.Content.startsWith("![CDATA[")) control.Content = control.Content.substring(8, control.Content.length - 10);
                        control.ContentType = "text/html";
                    }
                }

                // On affecte le contrôle à l'indice spécifié par control.key, cela permettra d'y accéder par la commande ctrls['clé'] (utilie pour les attributs)
                ctrls[control.Key] = control;
                ctrls.push(control);
            });

            // Balaye les actions et crée les boutons correspondants
            viewContext.Actions.map((a) => {
                let action = ActionModel.create(a);
                actions[action.Key] = action;
                actions.push(action);
            })

            this.setState({ tables: [] });

            //#region Lecture des attributs

            let attributes: object = null;
            try {
                attributes = JSON.parse(viewContext.Attributes);
            }
            catch (err) {
                dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContent, 3);
                console.log("*** Error in Attributes JSON. Check message below for further informations : ");
                console.log(err);
            }

            //#endregion 
            //#region Traitement des attributs de zones

            // => IMPORTANT : Il faut récupérer les attributs de zones AVANT la construction des tableaux et ce, pour pouvoir récupérer les attributs et les affecter aux tableaux lors de la création


            if (attributes) {
                if (attributes["Attributes"]["Flow"]) {
                    let ctrl: object[] = attributes["Attributes"]["Flow"][0];
                    for (let c in ctrl) {                                       // { [X1:{], X2:{}]} Ici on parse X1, X2 etc
                        for (let target in ctrl[c]) {
                            viewContext[target] = ctrl[c][target];
                        }
                    }
                }

                // Application des attributs sur les zones
                try {
                    // Converti le flux JSON en objet
                    let ctrl: object[] = attributes["Attributes"]["Controls"];

                    // Parse chaque objet, puis chaque propriété pour la transférer sur le control déjà en place
                    for (let c in ctrl) {                                       // { [X1:{], X2:{}]} Ici on parse X1, X2 etc
                        for (let target in ctrl[c]) {                           // ici on récupère le littéral X1 pour pouvoir cibler al destination
                            for (let prop in ctrl[c][target]) {                 // On parcours maintenant chaque propriétés
                                try {
                                    if (ctrls[target])
                                        ctrls[target][prop] = ctrl[c][target][prop];    // Et on met à jour 
                                }
                                catch (err) {
                                    dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContentFullZone.replace('%%0%%', prop).replace('%%1%%', target), 3);
                                    console.log("*** Error in Attributes JSON. Check message below for further informations : ");
                                    console.log(err);
                                }
                            }
                        }
                    }
                }
                catch (err) {
                    dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContent, 3);
                    console.log("Error in Attributes JSON. Check message below for further informations : ");
                    console.log(err);
                }

            }

            //#endregion Traitement des attributs de zones

            //#region Création des objets tableaux

            viewContext.TableDefs.map((x) => {
                let table = TableModel.create(x);

                // Applique les attributs des zones de tableaux sur les colonnes correspondantes
                try {
                    let ctrl: object[] = attributes["Attributes"]["Controls"];
                    for (let ctrlIndex in ctrl) {
                        for (let target in ctrl[ctrlIndex]) {
                            for (let prop in ctrl[ctrlIndex][target]) {
                                let column = table.colsDef.filter(c => c.FieldName == target)[0];
                                if (column)
                                    column[prop] = ctrl[ctrlIndex][target][prop];
                            }
                        }
                    }
                }
                catch (err) {
                    dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContent, 3);
                    console.log("Error in Attributes JSON (columns). Check message below for further informations : ");
                    console.log(err);
                }



                table.colsDef.filter(c => c.ColMergeTargets).map((col, index) => {
                    let colId: string = col.FieldName + "_" + col.ColMergeTargets.replace(";", "_");

                    let title: string = AppLabels[col.ColMergeTitle];
                    if (title == undefined) title = col.ColMergeTitle;

                    let c: IColumnDef = {
                        Class: col.ColMergeCSS,
                        Code: colId,
                        ColType: col.DataType,
                        Disable: col.Disable,
                        Title: title,
                        FieldName: colId,
                        SearchFieldName: col.ColSearchField,
                        Id: 50000 + col.Id,
                        Type: ControlTypeEnum.table,
                        Visible: col.Visible,
                        IsMerged: true,
                    }

                    // ON place la colonne à la place de la colonne source
                    table.colsDef.splice(index, 0, ColumnModel.create(c));

                });

                var ctrlTab = ctrls.filter(t => t.Id == x.Id)[0];
                if (ctrlTab != undefined) {

                    // 
                    table.bsSize = ctrlTab.bsSize;
                    table.DefaultSort = ctrlTab.DefaultSort;
                    table.BgRedCond = ctrlTab.BgRedCond;
                    table.BgOrangeCond = ctrlTab.BgOrangeCond;
                    table.BgYellowCond = ctrlTab.BgYellowCond;
                    table.BgGreenCond = ctrlTab.BgGreenCond;
                    table.TabRowDblClick = ctrlTab.TabRowDblClick;
                    table.TabAction1 = ctrlTab.TabAction1;
                    table.TabAction2 = ctrlTab.TabAction2;
                    table.Class = ctrlTab.Class;

                    table.TreeViewKeyPath = ctrlTab.TreeViewKeyPath;
                    table.TreeViewParentKeyPath = ctrlTab.TreeViewParentKeyPath;
                    table.TreeViewIsExpandedPath = ctrlTab.TreeViewIsExpandedPath;
                    table.TreeViewIconPath = ctrlTab.TreeViewIconPath;
                    table.TreeViewLevelPath = ctrlTab.TreeViewLevelPath;
                    table.NormBarcod = ctrlTab.NormBarcod;
                    table.BarCodCond = ctrlTab.BarCodCond;
                    table.ValidCond = ctrlTab.ValidCond;
                    table.TabAutoSelectSingleRow = ctrlTab.TabAutoSelectSingleRow;
                    table.TabAutoSelectAction = ctrlTab.TabAutoSelectAction;

                    table.ShowAsGraph = ctrlTab.ShowAsGraph;
                    table.GraphType = ctrlTab.GraphType;
                    table.GraphSeries = ctrlTab.GraphSeries;
                    table.GraphXPath = ctrlTab.GraphXPath;
                    table.GraphSeriesColor = ctrlTab.GraphSeriesColor;
                }

                let current = this.state.tables.filter(t => t.Key == x.Code)[0];
                if (current != undefined) {
                    table.actions = current.actions;
                }

                this.state.tables.push(table);
            });

            //#endregion Création des objets tableaux

            //#region Application des attributs sur les boutons
            // on le fait après la création des tableaux car ceux ci contiennent des actions

            if (attributes) {
                try {
                    // Converti le flux JSON en objet
                    let act: object[] = attributes["Attributes"]["Actions"];

                    // Parse chaque objet, puis chaque propriété pour la transférer sur le control déjà en place
                    for (let c in act) {                                       // { [X1:{], X2:{}]} Ici on parse X1, X2 etc
                        for (let target in act[c]) {                           // ici on récupère le littéral X1 pour pouvoir cibler al destination
                            for (let prop in act[c][target]) {                 // On parcours maintenant chaque propriétés
                                try {
                                    actions[target][prop] = act[c][target][prop];    // Et on met à jour 
                                }
                                catch (err) {
                                    this.state.tables.map((tt) => {
                                        let ac = tt.actions.filter(i => i.Key == target)[0];
                                        if (ac != undefined) {
                                            try {
                                                ac[prop] = act[c][target][prop];
                                            }
                                            catch (err) {
                                                dispatcher.MessageBox(AppLabels.jsonErrorTitle, AppLabels.jsonErrorContentFullZone.replace('%%0%%', prop).replace('%%1%%', target), 3);
                                                console.log("Error in Attributes JSON. Check message below for further informations : ");
                                                console.log(err);
                                            }
                                        }
                                    })
                                }
                            }
                        }
                    }
                }
                catch (err) {
                    console.log(err)
                }

            }

            //#endregion Application des attributs sur les boutons

            // On affecte un id panel par défaut pour les éléments qui z'en n'ont pas
            ctrls.map((x) => {
                if (x.IdPanel == "") x.IdPanel = "__defautPanel";

                if (x.DataType == InternalTypeEnum.Date) x.InputType = "date";
                if (x.DataType == InternalTypeEnum.Datetime) x.InputType = "time";
                if ((x.TypeLenght) && (x.MaxLength == undefined)) x.MaxLength = x.TypeLenght;

            });

            if (viewContext.MultiAnswers.length > 0) {
                let t = this.state.tables.filter(t => t.NormBarcod)[0];
                if (t != undefined) {
                    t.newRows = viewContext.MultiAnswers[0];
                }
            }

            let panels: PanelModel[] = [];

            ctrls.filter(c => c.Visible == true).map(c => {
                let pan = panels.filter(p => p.id == c.IdPanel)[0];
                if (pan == undefined)
                    panels.push({ id: c.IdPanel, collapsed: c.DivCollapsed ? true : false })
                else {
                    if (c.DivCollapsed == true) pan.collapsed = true;
                }
            });

            this.setState({
                disableHomeRedirection: viewContext.DisableHomeRedirection,
                Controls: ctrls,
                Actions: actions,
                tables: this.state.tables,
                currentStep: viewContext.Step,
                fonction: viewContext.FunctionName,
                nbCols: viewContext.LandscapeNbCols == 0 ? 1 : (viewContext.LandscapeNbCols % 4),
                panels: panels,
                showEmbedded: viewContext.ViewEmbeddedDoc,

            });
        }
        catch (err) {
            console.error(err);
        }
    }

    // Clic sur l'un des boutons action du tableau
    onActionClicked = async (table: TableModel, action: ActionModel, row: any) => {
        if (action.Action == 4) {
            this.setState({ popupCode: action.Key, isPopupOpen: true });
            return;
        }

        // Le bouton demande confirmation avant de poursuivre
        // On affiche donc la fenêtre via le dispatcher

        // On regarde si le text correspond à label traduit, si c'est le cas on prend le texte correspondant, sinon on affiche simplement le contenu de YesNo
        let text = AppLabels[action.YesNo];
        if (text == undefined) text = action.YesNo

        if (action.YesNo) {
            if (! await dispatcher.ConfirmBox(AppLabels.confirmTitle, text, AppLabels.yes, AppLabels.no))
                return;
        }

        let ctx: IViewContextParams = this.buildViewContextParams();
        ctx.context = action.Context;

        this.refreshContext(ctx);
    }

    // Clic sur un raccourci vers action (RUNACTIONLEFT ou RUNACTINMIDDLE)
    // Identique à KControlTable
    //
    onShortCutClick = (actionCodes: string) => {
        // Si pas de code, pourquoi traverserions nous la route ?
        if (!actionCodes) return;

        // Si plusieurs actions ont été définies dans l'attribut, on va aficher une fenêtre de sélection pour décider quelle action lancer
        let actions = actionCodes.split(";");
        if (actions.length > 1) {

            // On balaye les codes et on récupère les différents actions
            let list: ActionModel[] = [];
            for (let i = 0; i < actions.length; i++) {
                let action: ActionModel = this.state.Actions.filter(x => x.Key == actions[i])[0];
                if (action) list.push(action);
            }

            // On affiche la liste de sélection
            this.setState({ buttonList: list, showButtonList: true });
            return;
        }

        // 1 Seul code => on clique directement
        let field: ActionModel = this.state.Actions.filter(x => x.Key == actionCodes)[0];
        if (field) {
            this.onActionClick(field);
        }
    }

    // Sélection d'une action dans la liste définit dans onShortCutClick()
    // Si row est null, c'est qu'on a cliqué sur Annuler
    //
    onButtonListClose = (choice: IActionModel) => {
        this.setState({ showButtonList: false });

        if (choice) {
            let action = this.state.Actions.filter(a => a.Key == choice.Key)[0];
            if (action) this.onActionClick(action);
        }
    }

    // Click sur un bouton action
    // 
    onActionClick = async (field: ActionModel) => {
        if (field.Action == 4) {
            this.setState({ popupCode: field.Key, isPopupOpen: true });
            return;
        }

        // Le bouton demande confirmation avant de poursuivre
        // On affiche donc la fenêtre via le dispatcher

        // On regarde si le text correspond à label traduit, si c'est le cas on prend le texte correspondant, sinon on affiche simplement le contenu de YesNo
        let text = AppLabels[field.YesNo];
        if (text == undefined) text = field.YesNo

        if (field.YesNo) {
            if (! await dispatcher.ConfirmBox(AppLabels.confirmTitle, text, AppLabels.yes, AppLabels.no))
                return;
        }

        // Le champ contient une URL à laquelle il faut se rendre
        if (field.URL) {
            if (field.URL.startsWith("/") || field.URL.startsWith("http")) {
                this.setState({ redirectUrl: field.URL })
                return;
            }

            // Réinit de la vue
            this.state = {
                codecontext: "INITIALISATION",
                loading: true,
                redirectUrl: "",
                title: "",
                Controls: [],
                Actions: [],
                tables: [],
                focus: "",
                currentStep: 1,
                fonction: field.URL,
                disableHomeRedirection: false,

                showButtonList: false,
                buttonList: [],
                panels: [],
                showEmbedded: false,
                simulateMode: false,
                showResult: true,
                json: "",
                error: "",

                multiMode: false,

                isPopupOpen: false,
                popupCode: "",

                nbCols: 1,
                uploadedFiles: []
            };

            // Paramètres pour X3
            let ctx: IViewContextParams = {
                barCode: "",
                title: "",
                idTransaction: "",
                idSession: securitySvc.currentUser.id,
                idSite: "",
                context: this.state.codecontext,
                etape: this.state.currentStep,
                fnct: field.URL,
                Controls: [],
                Tables: [],
                Actions: [],
                uploadedFiles: []
            };

            // Chargement du contenu de la page
            this.refreshContext(ctx);
            return;
        }

        // Si attribut SKIPVALIDATION à true ou si la saisie du formulaire est correcte, on poursuit
        if (field.SkipValidation || this.checkFormValidity()) {
            let ctx: IViewContextParams = this.buildViewContextParams();
            ctx.context = field.Context;
            this.refreshContext(ctx);
        }
        else {
            // TODO: use enum
            dispatcher.MessageBox(AppLabels.inputErrorTitle, AppLabels.inputErrorDetail, 5)
        }
    }

    //#endregion

    //#region Outils de génération pour debug

    onJsonChange = (event) => {
        let value: string = event.target.value;
        this.setState({ json: value });
    }

    letsRock = (event) => {
        try {
            let obj: IAPICallResult<IViewContext> = JSON.parse(this.state.json);

            this.onViewContextReceived(obj.data);
            this.setState({ showResult: true });
            this.forceUpdate();

        }
        catch (err) {
            this.setState({ error: "Flux incorect" });
        }
    }

    renderGenerator = () => {
        if (!this.state.simulateMode) return "";
        var er = this.state.error;
        let alert = this.state.error != "" ? <CAlert color="danger">{er}</CAlert> : "";
        return (
            <div>
                <CContainer>
                    {alert}
                    <CToast>
                        <CToastHeader>
                            Saisie manuelle de flux
                        </CToastHeader>
                        <CToastBody>
                            Saisir le flux JSON résultat de de l'appel X1KMAPAGE <br />
                            Ce flux est trouvable via les logs APIS en mode DEBUG<br />
                            Seul le rendu est pris en charge.<br />
                            La gestion du retour (erreur, message, son) est ignorée.<br />
                        </CToastBody>
                    </CToast>

                    <CInput className="input" type="textarea" color="default" value={this.state.json} onChange={this.onJsonChange}  ></CInput>
                    <br />
                    <CButton onClick={this.letsRock} color="warning">Lets Rock !</CButton>
                </CContainer>
            </div>
        );
    }

    //#endregion

    // Survient lorsque de nouvelles lignes ont été ajoutées au tableau (depuis la saisie multiple)
    rowsAdded = (table: TableModel, rows: any[]) => {
        let ctx: IViewContextParams = this.buildViewContextParams();
        ctx.context = "BARCODCLIENT";
        ctx.barCode = "";

        let csv = "";
        if (rows.length > 0) {
            // Pour chaque ligne
            rows.map(row => {
                let csvRow = "";
                // Et chaque colonne
                table.colsDef.map(c => {
                    csvRow += ";";

                    if (row[c.FieldName]) {
                        csvRow += row[c.FieldName];
                    }
                });

                csv += csvRow.substr(1) + "\n";
            });
        }

        ctx.Tables.filter(t => t.Id == table.Id)[0].NewRows = csv;

        this.refreshContext(ctx);
    }

    //#region Rendering

    // Identique à KControlTable
    renderButtonList = () => {
        if (!this.state.showButtonList) return "";
        if (this.state.isPopupOpen) return "";
        return (
            <KActionList imageProvider={dispatcher} isOpen={this.state.showButtonList} title={AppLabels.selectActionTitle} choices={this.state.buttonList} closeCallBack={this.onButtonListClose} />
        );
    }

    renderButtonBar = (position: ActionPosition) => {
        // Il ne faut prendre que les boutons visibles & correspondant à la toolbar en cours.
        if (this.state.Actions.filter(a => a.Visible == true && a.Position == position).length == 0) return "";
        if (this.state.isPopupOpen) return "";

        let positionClass = "left";
        if ((position == ActionPosition.DockedUpperRight) || (position == ActionPosition.DockedBottomRight)) positionClass = "right"

        return <div className={"KControlButtonGroup " + positionClass} >
            {
                this.state.Actions.filter(p => p.Position == position).map((x, i) =>
                    <KControlAction imageProvider={dispatcher} key={i} Action={x} onClick={() => { this.onActionClick(x) }}></KControlAction>
                )
            }
        </div>
    }

    renderToolbarUp = () => {
        if (!this.state.showResult) return "";

        let toolbarUpperLeft = this.renderButtonBar(ActionPosition.DockedUpperLeft);
        let toolbarUpperRight = this.renderButtonBar(ActionPosition.DockedUpperRight);

        if (!toolbarUpperLeft && !toolbarUpperRight) return "";

        return (
            <div className="toolbar up">
                {toolbarUpperLeft}
                {toolbarUpperRight}
            </div>
        )
    }

    renderBottomToolbar = () => {
        if (!this.state.showResult) return "";

        let toolbarBottomLeft = this.renderButtonBar(ActionPosition.DockedBottomLeft);
        let toolbarBottomRight = this.renderButtonBar(ActionPosition.DockedBottomRight);

        //if (!toolbarBottomLeft && !toolbarBottomRight) return "";

        return (
            <div className="toolbar bottom">
                {toolbarBottomLeft}
                {toolbarBottomRight}
            </div>
        )
    }

    onChange = (x: ControlModel) => {
        if (!x.OnChange) return;
        if (x.OnChange == "") return;

        let ZV = this.state.Controls;

        try {
            eval(x.OnChange)
            this.forceUpdate();
        }
        catch (err) {
            console.log(err);
            dispatcher.MessageBox("Onchange Error in javascript", "Check console for more details", 3);
        }
    }

    onItemSelected = (x: ControlModel, value: string) => {
        if (!x.AutoAction) return;
        if (x.AutoAction == "") return;
        this.onShortCutClick(x.AutoAction);
    }

    renderView = (popupCode: string = "") => {
        if (!this.state.showResult) return "";

        let toolbarTop = this.renderToolbarUp();
        let panels: PanelModel[] = [];

        let ctrls: ControlModel[] = [];

        // Si pas de code popup, on prend tous les contrôles visibles
        if (popupCode == "") {
            ctrls = this.state.Controls.filter((a) => a.Visible == true);
        }
        else {
            // On a un code popup, on prend donc tous les contrôles liés à cette popup
            // On duplique les contrôles en stérilisant/désérialisant les contrôles existants
            // pour pouvoir les  passer tous à visible
            ctrls = JSON.parse(JSON.stringify(this.state.Controls.filter((a) => a.Popup == popupCode)));
            ctrls.map(c => c.Visible = true);
        }

        // Seuls les panels contenant au moins 1 élément sont affichés
        this.state.panels.map(pan => {
            let c = ctrls.filter((a) => a.IdPanel == pan.id);
            if (c.length > 0) panels.push(pan);
        });

        let nbCols = this.state.nbCols;
        if (this.state.isPopupOpen) nbCols = 1;
        if (window.innerWidth < window.innerHeight) nbCols = 1;

        return (
            <div className="stdview" >
                <div className="KBreadcrum ">
                    <span>{this.state.title}</span>
                </div>

                {this.renderToolbarUp()}

                <CContainer className={toolbarTop ? "shifted" : ""} style={{ columnCount: nbCols }} >
                    {
                        panels.map((pan, panId) => {
                            return (
                                <KPanel Id={panId} isExpanded={pan.collapsed == false} Title={AppLabels[pan.id] ? AppLabels[pan.id] : ""} key={panId} >
                                    <CRow>
                                        {
                                            ctrls
                                                .filter((a) => a.IdPanel == pan.id)
                                                .sort((a, b) => { return (Number(a.Id) > Number(b.Id)) ? 1 : -1 })
                                                .map((x, i) => {
                                                    switch (Number(x.ControlType)) {
                                                        case ControlTypeEnum.label:
                                                            return <KControlLabel key={i} Control={x}></KControlLabel>

                                                        case ControlTypeEnum.progress:
                                                            return <KControlProgress key={i} Control={x}></KControlProgress>

                                                        case ControlTypeEnum.jauge:
                                                            return <KControlJauge key={i} Control={x}></KControlJauge>

                                                        case ControlTypeEnum.document:
                                                            return <KControlAttachment ShowEmbedded={this.state.showEmbedded} dispatcher={dispatcher} key={i} Control={x}></KControlAttachment>

                                                        case ControlTypeEnum.input:
                                                            return <KControlInput onChange={(e) => this.onChange(x)} imageProvider={dispatcher} msgBoxProvider={dispatcher} virtualKeyboard={dispatcher} key={i} Control={x} onShortCutClick={this.onShortCutClick} ></KControlInput>

                                                        case ControlTypeEnum.select:
                                                        case ControlTypeEnum.selectControled:
                                                        case ControlTypeEnum.selectFree:
                                                            return <KControlSelect dispatcher={dispatcher} key={i} control={x} onShortCutClick={this.onShortCutClick} onItemSelected={this.onItemSelected} ></KControlSelect>

                                                        case ControlTypeEnum.selectDynamic:
                                                            return <KControlSelect
                                                                dispatcher={dispatcher}
                                                                key={i}
                                                                onShortCutClick={this.onShortCutClick}
                                                                onItemSelected={this.onItemSelected}
                                                                control={x}
                                                                getViewstate={() => { return this.getDynamicListParams(); }} ></KControlSelect>

                                                        case ControlTypeEnum.checkbox:
                                                            return <KControlCheckbox imageProvider={dispatcher} key={i} control={x}></KControlCheckbox>

                                                        case ControlTypeEnum.table:
                                                            let tab = this.state.tables.filter((t) => t.Key == x.Key)[0];
                                                            if (tab != undefined) {
                                                                return <KControlTableSwitch dispatcher={dispatcher} imageProvider={dispatcher} onActionClicked={this.onActionClicked} key={i} table={tab} onRowsAdded={this.rowsAdded} hideActionBar={false}></KControlTableSwitch >
                                                            }
                                                            return null;

                                                        case ControlTypeEnum.image:
                                                            return <KControlImage key={i}
                                                                imgProvider={dispatcher}
                                                                bsSize={Utils.getColSizeClasses(x)}
                                                                Class={x.Class}
                                                                Content={x.Content}
                                                                Description={x.Description}
                                                                InlineStyle={x.InlineStyle}
                                                                ShowHeader={true}
                                                                Key={x.Key}
                                                                ShowMoreIcon={x.ShowMoreIcon}
                                                                Visible={x.Visible}
                                                                ContentType={x.ContentType}
                                                                ShowMoreOnLoad={x.ShowMoreOnLoad}
                                                            >
                                                            </KControlImage>

                                                        case ControlTypeEnum.viewerHtml:
                                                        case ControlTypeEnum.htmlEditor:
                                                            return <KControlHTMLEditor
                                                                imageProvider={dispatcher}
                                                                key={i} bsSize={Utils.getColSizeClasses(x)}
                                                                ShowMoreOnLoad={x.ShowMoreOnLoad}
                                                                control={x}
                                                            />

                                                        case ControlTypeEnum.viewerRTF:
                                                            return <KControlRTF
                                                                imageProvider={dispatcher}
                                                                key={i} bsSize={Utils.getColSizeClasses(x)}
                                                                ShowMoreOnLoad={x.ShowMoreOnLoad}
                                                                control={x}
                                                            />

                                                    }
                                                })
                                        }
                                    </CRow>
                                </KPanel>)
                        }
                        )
                    }
                </CContainer>

                {this.renderBottomToolbar()}
            </div>
        );
    }

    render() {
        if (!securitySvc.isAuth()) return <Redirect to="/"></Redirect>
        if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>
        if (this.state.loading) return null;

        let view = this.renderView();
        let popup = this.state.isPopupOpen ? this.renderView(this.state.popupCode) : "";
        let generator = this.renderGenerator();
        let buttonList = this.renderButtonList();

        return (
            <React.Fragment>
                <NavMenu disableRedirection={dispatcher.getLastViewContext()} securityService={securitySvc} userFullName={securitySvc.currentUser.fullname} />

                {view}
                {buttonList}
                {generator}

                <CModal centered closeOnBackdrop={false} className={"KPopupForm "} show={this.state.isPopupOpen} onClose={() => this.setState({ isPopupOpen: !this.state.isPopupOpen })} >
                    <CModalBody>
                        {popup}
                    </CModalBody>
                    <CModalFooter>
                        <CButton color='primary' onClick={() => this.setState({ isPopupOpen: !this.state.isPopupOpen })}>✖ {AppLabels.close}</CButton>
                    </CModalFooter>
                </CModal>
            </React.Fragment>
        );
    }

    //#endregion
}
